// Client-side image compression for fast mobile uploads.
export async function compressImage(file, maxDim = 1600, quality = 0.85) {
  if (!file.type.startsWith("image/")) return file;
  if (file.size < 200 * 1024) return file;

  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    width = Math.round(width * scale);
    height = Math.round(height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();

    return await new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) return resolve(file);
          const newFile = new File(
            [blob],
            file.name.replace(/\.[^.]+$/, "") + ".jpg",
            { type: "image/jpeg", lastModified: Date.now() }
          );
          resolve(newFile);
        },
        "image/jpeg",
        quality
      );
    });
  } catch (e) {
    console.warn("Image compress failed, uploading original:", e);
    return file;
  }
}
